import { CheckCircle, XCircle } from "lucide-react";
import { Badge } from "../ui/badge";
import { ConfiguredState } from "../../models/audit/control";

// The colours/padding/weight below restate what the hand-rolled pills used, so
// the rendered result is unchanged; `secondary` is only here for its
// `border-transparent`, and its hover tint is overridden back to flat because
// these pills aren't interactive.
const STATE_STYLES: Record<
  ConfiguredState,
  { label: string; className: string }
> = {
  [ConfiguredState.Configured]: {
    label: "Configured",
    className: "bg-green-100 text-green-700 hover:bg-green-100",
  },
  [ConfiguredState.Draft]: {
    label: "Draft",
    className: "bg-gray-100 text-gray-700 hover:bg-gray-100",
  },
  [ConfiguredState.NotConfigured]: {
    label: "Not Configured",
    className: "bg-yellow-100 text-yellow-700 hover:bg-yellow-100",
  },
};

export const ConfiguredStateBadge = ({ state }: { state: ConfiguredState }) => {
  const { label, className } = STATE_STYLES[state];
  const Icon = state === ConfiguredState.Configured ? CheckCircle : XCircle;
  return (
    <Badge
      variant="secondary"
      className={`gap-1.5 py-1 font-medium ${className}`}
    >
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  );
};
